import { LOCAL_STORAGE_TOKEN_KEY } from 'constants/auth'
import { ESTABLISHMENT_APP_TIMESTAMP_VERSION_KEY } from 'constants/establishment'
import { getItemLocalStorage, setItemLocalStorage } from 'utils/local-storage'

const applyInterceptors = (axiosInstance) => {
  // Interceptor de solicitud
  axiosInstance.interceptors.request.use(
    (config) => {
      const token = getItemLocalStorage(LOCAL_STORAGE_TOKEN_KEY)
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }
      return config
    },
    (error) => Promise.reject(error)
  )

  // Interceptor de respuesta
  axiosInstance.interceptors.response.use(
    (response) => {
      const appTimestampVersion = Number(response.data?.app_timestamp_version)

      if (!isNaN(appTimestampVersion) && appTimestampVersion > 0) {
        const currentAppTimestampVersion = Number(getItemLocalStorage(ESTABLISHMENT_APP_TIMESTAMP_VERSION_KEY))

        if (appTimestampVersion > currentAppTimestampVersion) {
          setItemLocalStorage(ESTABLISHMENT_APP_TIMESTAMP_VERSION_KEY, appTimestampVersion)
          window.location.reload()
        }
      }

      return response
    },
    (error) => {
      if (error.response?.status === 401) {
        console.error(error.response)
      }

      if (error.response?.status === 403) {
        console.error(error.response)
      }

      return Promise.reject(error)
    }
  )
}

export default applyInterceptors